/**
 * Translate Dropdown Module (Google Translate Integration)
 */

function getCookie(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function clearTranslateCookie() {
    const hostname = window.location.hostname;
    const rootDomain = hostname.replace(/^www\./, "");
    const domains = ["", hostname, `.${hostname}`, `.${rootDomain}`];
    const paths = ["/", ""];

    domains.forEach((d) => {
        paths.forEach((p) => {
            const dStr = d ? `; domain=${d}` : "";
            const pStr = p ? `; path=${p}` : "";
            document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC${pStr}${dStr}`;
            document.cookie = `googtrans=; Max-Age=0${pStr}${dStr}`;
        });
    });
}

export function setTranslateCookie(lang) {
    const hostname = window.location.hostname;
    const rootDomain = hostname.replace(/^www\./, "");
    const cookieVal = `/en/${lang}`;

    // Clear previous cookies first to avoid domain collision
    clearTranslateCookie();

    document.cookie = `googtrans=${cookieVal}; path=/`;
    if (hostname.includes(".")) {
        document.cookie = `googtrans=${cookieVal}; path=/; domain=.${rootDomain}`;
        document.cookie = `googtrans=${cookieVal}; path=/; domain=${hostname}`;
    }
}

export function GTranslateGetCurrentLang() {
    const val = getCookie("googtrans");
    if (!val || val === "/en/en") return null;
    const parts = val.split("/");
    return parts.length >= 3 ? parts[2] : null;
}

function GTranslateFireEvent(element, event) {
    try {
        if (document.createEvent) {
            const evt = document.createEvent("HTMLEvents");
            evt.initEvent(event, true, true);
            element.dispatchEvent(evt);
        } else {
            element.dispatchEvent(new Event(event, { bubbles: true, cancelable: true }));
        }
    } catch (e) {
        try {
            element.dispatchEvent(new Event(event, { bubbles: true, cancelable: true }));
        } catch (e2) {}
    }
}

let retryCount = 0;
const MAX_RETRIES = 25;

export function doGTranslate(lang_pair) {
    if (!lang_pair) return;
    const langValue = typeof lang_pair === "string" ? lang_pair : lang_pair.value;
    if (!langValue) return;

    const lang = langValue.split("|")[1] || "";

    // If switching back to English (or original language)
    if (lang === "en" || lang === "") {
        clearTranslateCookie();
        updateDocumentDirection("en");

        const teCombo = document.querySelector("select.goog-te-combo");
        if (teCombo) {
            teCombo.value = "";
            GTranslateFireEvent(teCombo, "change");
        }

        // Clean reload to restore pristine original English DOM
        window.location.reload();
        return;
    }

    setTranslateCookie(lang);
    updateDocumentDirection(lang);
    changeOpenerLang();

    const teCombo = document.querySelector("select.goog-te-combo");
    const targetElem = document.getElementById("google_translate_element2");

    if (
        !targetElem ||
        !targetElem.innerHTML.trim() ||
        !teCombo ||
        !teCombo.options ||
        teCombo.options.length === 0
    ) {
        if (retryCount < MAX_RETRIES) {
            retryCount++;
            setTimeout(function () {
                doGTranslate(langValue);
            }, 250);
        }
    } else {
        retryCount = 0;
        teCombo.value = lang;
        GTranslateFireEvent(teCombo, "change");
        GTranslateFireEvent(teCombo, "change");
        if (typeof teCombo.onchange === "function") {
            try {
                teCombo.onchange();
            } catch (e) {}
        }
    }
}

export function googleTranslateElementInit2() {
    if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: "en",
                autoDisplay: false,
            },
            "google_translate_element2"
        );
    }
}

// Expose on window so Google Translate callback finds it
if (typeof window !== "undefined") {
    window.googleTranslateElementInit2 = googleTranslateElementInit2;
}

/**
 * On-Demand Google Translate Script Loader
 * Dynamically loads element.js and its dependencies on user intent (hover/focus/click)
 * or immediately if a non-English language cookie is already stored.
 */
let googleTranslatePromise = null;

export const loadGoogleTranslateScript = () => {
    if (typeof window !== "undefined" && window.google && window.google.translate) {
        googleTranslateElementInit2();
        return Promise.resolve(window.google.translate);
    }

    if (googleTranslatePromise) {
        return googleTranslatePromise;
    }

    googleTranslatePromise = new Promise((resolve, reject) => {
        // Expose callback on window
        window.googleTranslateElementInit2 = () => {
            googleTranslateElementInit2();
            if (window.google && window.google.translate) {
                resolve(window.google.translate);
            }
        };

        const existingScript = document.querySelector('script[src*="translate.google.com"]');
        if (existingScript) {
            // Already in DOM (e.g. from legacy template tag), wait for it to initialize
            const checkInterval = setInterval(() => {
                if (window.google && window.google.translate) {
                    clearInterval(checkInterval);
                    googleTranslateElementInit2();
                    resolve(window.google.translate);
                }
            }, 100);
            setTimeout(() => clearInterval(checkInterval), 10000);
            return;
        }

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2";

        script.onload = () => {
            if (window.google && window.google.translate) {
                googleTranslateElementInit2();
                resolve(window.google.translate);
            }
        };

        script.onerror = (err) => {
            googleTranslatePromise = null;
            reject(err);
        };

        document.head.appendChild(script);
    });

    return googleTranslatePromise;
};

/**
 * Safe Brand Name Protection for Google Translate
 * Prevents "Wood" from being translated into literal "timber" ("الخشب" in Arabic, "Madera", etc.)
 * Strictly skips scripts, styles, and JSON-LD schema tags so SEO is 100% protected.
 */
export const protectBrandNamesFromTranslation = () => {
    if (typeof document === "undefined") return;
    try {
        const containers = document.querySelectorAll(
            "header, main, footer, .page-wrapper, .c-hero, .cards, article, nav"
        );
        containers.forEach((container) => {
            const walker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT,
                {
                    acceptNode: function (node) {
                        const parent = node.parentElement;
                        if (!parent) return NodeFilter.FILTER_REJECT;
                        const tag = parent.tagName.toLowerCase();
                        if (
                            tag === "script" ||
                            tag === "style" ||
                            tag === "noscript" ||
                            tag === "textarea" ||
                            tag === "code" ||
                            tag === "pre"
                        ) {
                            return NodeFilter.FILTER_REJECT;
                        }
                        if (parent.closest("script, style, noscript, .notranslate, [translate='no']")) {
                            return NodeFilter.FILTER_REJECT;
                        }
                        if (node.nodeValue && /\bWood\b/.test(node.nodeValue)) {
                            return NodeFilter.FILTER_ACCEPT;
                        }
                        return NodeFilter.FILTER_SKIP;
                    },
                }
            );

            const nodesToReplace = [];
            let currentNode = walker.nextNode();
            while (currentNode) {
                nodesToReplace.push(currentNode);
                currentNode = walker.nextNode();
            }

            nodesToReplace.forEach((node) => {
                if (!node.parentNode) return;
                const text = node.nodeValue;
                const newHtml = text.replace(
                    /\bWood(?=[\s\.,'’\-;:!?]|$)/g,
                    '<span class="notranslate" translate="no">Wood</span>'
                );
                if (newHtml !== text) {
                    const fragment = document.createRange().createContextualFragment(newHtml);
                    node.parentNode.replaceChild(fragment, node);
                }
            });
        });
    } catch (e) {
        // Fail silently
    }
};

/**
 * Document Reading Direction Manager (Option A - Content-Only RTL)
 * Adds .is-arabic and .is-rtl classes for natural text alignment
 * WITHOUT flipping the structural grid/flex layout (avoids hero and search breakage).
 */
export const updateDocumentDirection = (langCode) => {
    if (typeof document === "undefined") return;
    // Always ensure dir="rtl" is removed from <html> so structural layout does not flip
    document.documentElement.removeAttribute("dir");

    if (langCode === "ar") {
        document.documentElement.classList.add("is-arabic", "is-rtl");
        protectBrandNamesFromTranslation();
    } else {
        document.documentElement.classList.remove("is-arabic", "is-rtl");
    }
};

export const changeOpenerLang = () => {
    const wrapper = document.querySelector(".r-translate-wrapper");
    const opener = wrapper
        ? wrapper.querySelector(".custom-select-opener")
        : document.querySelector(".header .custom-select-opener");

    if (!opener) return;

    // Accessibility label fix
    if (!opener.hasAttribute("aria-label") || opener.getAttribute("aria-label") !== "Select language") {
        opener.setAttribute("aria-label", "Select language");
    }

    const googtransValue = getCookie("googtrans");
    let openerLang = "EN";
    if (googtransValue && googtransValue !== "/en/en") {
        openerLang =
            googtransValue
                .split("/")
                .pop()
                .toUpperCase()
                .split("-")
                .pop() || "EN";
    }

    const newOpenerSpan = opener.querySelector(".new-opener");
    if (newOpenerSpan) {
        newOpenerSpan.innerText = openerLang;
    } else {
        const newOpener = document.createElement("span");
        newOpener.setAttribute("class", "new-opener notranslate");
        newOpener.setAttribute("translate", "no");
        newOpener.innerText = openerLang;
        opener.appendChild(newOpener);
    }
};

export const checkSelectOption = () => {
    const gtSelect = document.querySelector(".r-translate-wrapper .gt__select, .gt__select");
    if (!gtSelect || !gtSelect.customSelect) return;

    const googtransVal = getCookie("googtrans");
    if (googtransVal && googtransVal !== "/en/en") {
        const parts = googtransVal.split("/");
        const lang = parts[parts.length - 1];
        if (lang) {
            gtSelect.customSelect.value = `en|${lang}`;
        }
    } else {
        gtSelect.customSelect.value = "en|en";
    }
};

export const initTranslateDropdown = () => {
    const gtSelect = document.querySelector(".r-translate-wrapper .gt__select, .gt__select");
    if (!gtSelect) return;

    const wrapper =
        gtSelect.closest(".r-translate-wrapper") ||
        gtSelect.closest(".custom-select-container") ||
        gtSelect.parentElement;

    // Prevent Google Translate from translating the language switcher elements
    if (wrapper) {
        wrapper.classList.add("notranslate");
        wrapper.setAttribute("translate", "no");
        const panel = wrapper.querySelector(".custom-select-panel");
        if (panel) {
            panel.classList.add("notranslate");
            panel.setAttribute("translate", "no");
        }
    }

    // Global delegated click listener for language option selection
    if (typeof window !== "undefined" && !window._translateClickBound) {
        window._translateClickBound = true;
        document.addEventListener("click", function (e) {
            const option = e.target.closest(".custom-select-option");
            if (!option) return;
            const translateContainer = option.closest(".r-translate-wrapper, .custom-select-container");
            if (!translateContainer) return;
            const targetSelect = translateContainer.querySelector(".gt__select");
            if (!targetSelect) return;

            const val = option.getAttribute("data-value");
            if (val) {
                targetSelect.value = val;
                if (targetSelect.customSelect) {
                    targetSelect.customSelect.value = val;
                    targetSelect.customSelect.open = false;
                }
                const langCode = val.split("|").pop() || "en";
                loadGoogleTranslateScript().then(() => {
                    doGTranslate(val);
                });
                changeOpenerLang();
                updateDocumentDirection(langCode);
            }
        });
    }

    // Accessibility: Ensure native select has an accessible label
    if (!gtSelect.hasAttribute("aria-label")) {
        gtSelect.setAttribute("aria-label", "Select language");
    }

    // Check if user has an active non-English translation cookie
    const googtransValue = getCookie("googtrans");
    const isTranslated =
        googtransValue &&
        googtransValue !== "/en/en" &&
        !googtransValue.endsWith("/en");

    if (isTranslated) {
        // Eagerly load so returning user has instant translation without flash
        loadGoogleTranslateScript();
        const activeLang = googtransValue.split("/").pop();
        updateDocumentDirection(activeLang);
    } else {
        // Intent-based prefetching for default English users (hover, focus, click)
        const triggerPrefetch = () => {
            loadGoogleTranslateScript();
        };

        if (wrapper && !wrapper.dataset.prefetchBound) {
            wrapper.dataset.prefetchBound = "true";
            wrapper.addEventListener("pointerenter", triggerPrefetch, {
                once: true,
                passive: true,
            });
            wrapper.addEventListener("focusin", triggerPrefetch, {
                once: true,
                passive: true,
            });
            wrapper.addEventListener("click", triggerPrefetch, {
                once: true,
                passive: true,
            });
        }
    }

    // Attach change listener if not already bound
    if (!gtSelect.dataset.translateBound) {
        gtSelect.dataset.translateBound = "true";
        gtSelect.addEventListener("change", function () {
            const langValue = gtSelect.value;
            const langCode = langValue.split("|").pop() || "en";
            loadGoogleTranslateScript().then(() => {
                doGTranslate(langValue);
            });
            changeOpenerLang();
            updateDocumentDirection(langCode);
        });
    }

    changeOpenerLang();
    checkSelectOption();
};

// Auto-run on DOM ready and after ticks to ensure customSelect has enhanced the opener
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        initTranslateDropdown();
        setTimeout(changeOpenerLang, 200);
        setTimeout(changeOpenerLang, 800);
        setTimeout(changeOpenerLang, 1500);
    });
} else {
    initTranslateDropdown();
    setTimeout(changeOpenerLang, 200);
    setTimeout(changeOpenerLang, 800);
    setTimeout(changeOpenerLang, 1500);
}

export default initTranslateDropdown;


